"use client";

import { c as _c } from "react/compiler-runtime";
import type { CategoryEnum } from "@sprawdzonabron/shared";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useEffect, useMemo, useState } from "react";
import { useDebounce } from "../../hooks/useDebounce";
import { useWindowSize } from "../../hooks/useWindowSize";
import { selectFilters, selectMobileFiltersOpen, useSelector } from "../../store/selectors";
import { useStoreSlices } from "../../store/slices";
import { omitEmpty } from "../../utils/omitEmpty";
import { URLParamEnum } from "../urlParams/types";
import { areFiltersDefault, getFilters } from "./utils";
export const useSyncFilters = t0 => {
  const $ = _c(27);
  const {
    defaultCategory,
    defaultSearch,
    defaultProducer,
    defaultCity
  } = t0;
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const {
    isMobile
  } = useWindowSize();
  const mobileFiltersOpen = useSelector(selectMobileFiltersOpen);
  let t1;
  if ($[0] !== defaultCategory || $[1] !== defaultCity || $[2] !== defaultProducer || $[3] !== defaultSearch) {
    t1 = omitEmpty({
      category: defaultCategory,
      city: defaultCity,
      producer: defaultProducer,
      search: defaultSearch
    });
    $[0] = defaultCategory;
    $[1] = defaultCity;
    $[2] = defaultProducer;
    $[3] = defaultSearch;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const filtersOverrides = t1;
  let t2;
  if ($[5] !== filtersOverrides) {
    t2 = getFilters(new URLSearchParams(), filtersOverrides);
    $[5] = filtersOverrides;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const defaultFiltersForPage = t2;
  let t3;
  if ($[7] !== filtersOverrides) {
    t3 = JSON.stringify(filtersOverrides);
    $[7] = filtersOverrides;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const overridesKey = t3;
  const [initializedKey, setInitializedKey] = useState(null);
  const isInitialized = initializedKey === overridesKey;
  const {
    setFilters
  } = useStoreSlices();
  const filters = useSelector(selectFilters);
  const debouncedFilters = useDebounce(filters, 500);
  let t4;
  let t5;
  if ($[9] !== filtersOverrides || $[10] !== isInitialized || $[11] !== overridesKey || $[12] !== searchParams || $[13] !== setFilters) {
    t4 = () => {
      if (isInitialized) {
        return;
      }
      const filters_0 = getFilters(searchParams, filtersOverrides);
      setFilters(filters_0);
      setInitializedKey(overridesKey);
    };
    t5 = [overridesKey, searchParams, setFilters, isInitialized, filtersOverrides];
    $[9] = filtersOverrides;
    $[10] = isInitialized;
    $[11] = overridesKey;
    $[12] = searchParams;
    $[13] = setFilters;
    $[14] = t4;
    $[15] = t5;
  } else {
    t4 = $[14];
    t5 = $[15];
  }
  useEffect(t4, t5);
  let t6;
  let t7;
  if ($[16] !== debouncedFilters || $[17] !== defaultFiltersForPage || $[18] !== filters || $[19] !== isInitialized || $[20] !== isMobile || $[21] !== mobileFiltersOpen || $[22] !== pathname || $[23] !== router || $[24] !== searchParams) {
    t6 = () => {
      if (isMobile && mobileFiltersOpen || !isInitialized) {
        return;
      }
      if (JSON.stringify(filters) !== JSON.stringify(debouncedFilters)) {
        return;
      }
      const newSearchParams = new URLSearchParams(searchParams);
      if (areFiltersDefault(debouncedFilters, defaultFiltersForPage)) {
        if (searchParams.has(URLParamEnum.Filters)) {
          newSearchParams.delete(URLParamEnum.Filters);
          const newSearch = newSearchParams.toString();
          router.push(pathname + (newSearch ? `?${newSearch}` : ""), {
            scroll: false
          });
        }
      } else {
        newSearchParams.set(URLParamEnum.Filters, JSON.stringify(omitEmpty(debouncedFilters)));
        if (newSearchParams.toString() !== searchParams.toString()) {
          router.push(`?${newSearchParams.toString()}`, {
            scroll: false
          });
        }
      }
    };
    t7 = [debouncedFilters, isMobile, router, searchParams, mobileFiltersOpen, filters, isInitialized, defaultFiltersForPage, pathname];
    $[16] = debouncedFilters;
    $[17] = defaultFiltersForPage;
    $[18] = filters;
    $[19] = isInitialized;
    $[20] = isMobile;
    $[21] = mobileFiltersOpen;
    $[22] = pathname;
    $[23] = router;
    $[24] = searchParams;
    $[25] = t6;
    $[26] = t7;
  } else {
    t6 = $[25];
    t7 = $[26];
  }
  useEffect(t6, t7);
};